module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Semibold.bfddc2a3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Semibold.ttf
// module id = 2543
// module chunks = 7